// MainCalculators.js (Chemistry version)
import React from "react";
import { chemistryCalculators } from "./ConstantsChemistryCalculator";
function MainCalculatorsList() {
  let calculatorsList = chemistryCalculators;
  let calculatorName = "Kalkulator Kimia";
  return (
    <div>
      <div
        className="bg-success text-white text-center"
        style={{ height: "50px" }}
      >
        <b>{calculatorName}</b>
      </div>
      <div className="border border-light">
        <ul>
          {calculatorsList.map((item, index) => item.showMain &&(
            <li key={index}>
              <a href={item.link} className="item-link">
                {item.name}
              </a>
            </li>
          ))}
        </ul>
        <div style={{ textAlign: "center" }}>
          <a
            className="btn btn-success"
            style={{ width: "90%" }}
            href={"/id/chemistry-calculators/"}
          >
            Lainnya
          </a>
          <hr />
        </div>
         </div>
</div>
  );
}
export default MainCalculatorsList;